module.exports = __webpack_public_path__ + "img/pcard3.7289c1b9.png";